import { FaiProduct } from '@app-types/fai';
import { CheckoutFundingType, PaymentMethodType } from '@app-types/order';
import { PRICE_TYPE } from '@app-types/price';
import { Connectivity, FundingEnumType, PlanType, PriceType } from '@app-types/product';

export const clippBodyHandler = (toogle: boolean): void => {
    if (typeof document !== 'object') return;
    const body = document.querySelector('body');
    if (body === null) return;
    if (toogle) body.classList.add('is-clipped');
    else body.classList.remove('is-clipped');
};

export const scrollToElement = (id: string) => {
    try {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            setTimeout(() => {
                scrollToElement(id);
            }, 100);
        }
    } catch (error) {
        //
    }
};

export function spaceAndDotSanitizer(v = '') {
    return v.replace(/\s|\.|_/g, '');
}

export const anonymizeSiren = (siren: string): string => {
    if (!siren?.length) {
        return '';
    }

    if (siren.length <= 3) {
        return siren.replace(/./g, '*');
    }

    return siren.slice(0, -3).replace(/./g, '*') + siren.slice(-3);
};

export function getFundingTypeCash(fundingType: CheckoutFundingType[]) {
    const fy = fundingType.find((mode) => mode.type === FundingEnumType.CASH);
    const isPaymentMethodIban = !!(
        fy &&
        fy.paymentMethods.find((t) => {
            return t.type === PaymentMethodType.FREE;
        })
    );

    const fundingMethods = fy?.paymentMethods.filter((method) => method.type !== PaymentMethodType.PAYPAL);

    return {
        fundingTypes: fundingMethods ?? [],
        isPaymentMethodIban,
    };
}

export const maskPhoneInput = (input: HTMLInputElement) => {
    return input.value.replace(/\D/g, '').replace(/(\d{2})(?=\d)/g, '$1 ');
};

export const calculFinalPrice = (
    selectedNetwork: Connectivity | null,
    selectedProduct?: PlanType | FaiProduct | null,
    faiProduct?: FaiProduct | null,
) => {
    if (!selectedProduct) {
        return { now: 0, forever: 0, duration: 0 };
    }

    const optionPrice = getOptionPrice(selectedNetwork, selectedProduct);
    const planPrice = getPlanPrice(selectedProduct, faiProduct);

    return {
        now: optionPrice + planPrice.now,
        forever: optionPrice + planPrice.forever,
        duration: planPrice.duration,
    };
};

const getOptionPrice = (
    selectedNetwork: Connectivity | null,
    selectedProduct?: PlanType | FaiProduct | null,
): number => {
    if (!selectedProduct || !('option5g' in selectedProduct)) {
        return 0;
    }

    return selectedNetwork === Connectivity.FIVE_G ? selectedProduct?.option5g?.prices?.final || 0 : 0;
};

const getPlanPrice = (planSelected: PlanType | FaiProduct, faiOfferSelected?: FaiProduct | null) => {
    let matchingPrice: PriceType | undefined = planSelected.prices;
    if (faiOfferSelected) {
        matchingPrice =
            planSelected.prices.pricesWithBboxIncentive?.[
                faiOfferSelected?.commercial_series as 'max' | 'standard' | 'serie_client_bandyou'
            ];
    }
    return {
        now: matchingPrice?.final ?? planSelected.prices?.final ?? 0,
        forever: matchingPrice?.forever ?? planSelected.prices?.forever ?? 0,
        duration: matchingPrice?.duration ?? planSelected.prices?.duration ?? 0,
    };
};

export const getPriceType = (priceType: string): PRICE_TYPE => {
    switch (priceType) {
        case 'IMMEDIAT':
            return PRICE_TYPE.TODAY;
        case 'MENSUEL':
            return PRICE_TYPE.MONTHLY;
        case 'DIFFERE':
            return PRICE_TYPE.DEFERRED;
        case 'AUTRE':
            return PRICE_TYPE.OTHER;
        default:
            return PRICE_TYPE.TODAY;
    }
};

export const removeSpacesFromString = (str?: string): string => {
    if (!str) {
        return '';
    }
    return str.replace(/\s/g, '');
};

export const formatPhoneNumber = (phone = ''): string => {
    return phone.replace(/(\d{2})(?=\d)/g, '$1.');
};

export const formatPrice = (amount: number) => {
    return amount?.toLocaleString('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    });
};

export const roundDecimal = (amount: number) => {
    return Math.round(amount * 100) / 100;
};
